/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagSearchFilter } from './tagSearchFilter';


export interface TagSearchRequest { 
    /**
     * A list of tag search filters. Only a single optional search filter is supported
     */
    tagSearchFilters?: Array<TagSearchFilter>;
}
